import request from "@/utils/requestSC";

// 查询代付协议内容
export async function queryPaymentOnBehalfTreaty(params) {
  return request.get("/rest/contract/queryPaymentOnBehalfTreaty", {
    params
  });
}

// 簽署代付协议内容
export async function signPaymentOnBehalfTreaty(params) {
  return request.get("/rest/contract/toSignPaymentOnBehalfTreaty", {
    params
  });
}
